import { Localized } from "@fluent/react"
import { DialogTitle, DialogContent, DialogContentText, DialogActions, Alert, Typography, TextField } from "@mui/material"
import { useState } from "react";
import { useAppDispatch } from "../../../app/hooks";
import { showSuccess } from "../../notifications/notificationsSlice";
import { AppUser, archiveAppUser } from "../administration";
import { CancelButton } from "../../../app/components/CancelButton";
import { ArchiveButton } from "../../../app/components/ArchiveButton";

export interface ArchiveUserDialogProps {
    email: string;
    onSuccessfullySaved: (updated: any) => void;
    onCancel: () => void
}

export const ArchiveUserDialog = ({ email, onSuccessfullySaved, onCancel }: ArchiveUserDialogProps) => {
    const dispatch = useAppDispatch()
    const [loading, setLoading] = useState<boolean>(false);
    const [reason, setReason] = useState("");
    const [password, setPassword] = useState("");
    const [serverError, setServerError] = useState("");

    const handleSubmitClick = async () => {
        try {
            setLoading(true)
            const result = await dispatch(archiveAppUser({ email, reason, password }));
            if (archiveAppUser.fulfilled.match(result)) {
                result.payload as AppUser;
                dispatch(showSuccess("saved"))
                onSuccessfullySaved({ status: "ARCHIVED", lockedAt: result.payload.lockedAt, lockedBy: result.payload.lockedBy, lockReason: result.payload.lockReason });
            }
            else {
                let errorMsg = "error"
                if (result.payload) {
                    if (result.payload.kind === 'http') {
                        const problem = result.payload.problem
                        if (problem) {
                            errorMsg = problem.title
                        }
                    }
                }
                setServerError(errorMsg)
            }
        } catch (error) {
            setServerError("error");
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <DialogTitle>
                <Localized id="user-archive-dialog-title">
                    <span>_Archiwizuj użytkownika</span>
                </Localized>
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <Alert
                        severity="info"
                        variant="outlined"
                        sx={{
                            mb: 2,
                            mt: 2,
                            alignItems: "flex-start",
                            "& .MuiAlert-message": {
                                width: "100%",
                            },
                        }}
                    >
                        <Typography variant="body2">
                            <Localized id="user-archive-dialog-alert">
                                <span>_Treść alertu</span>
                            </Localized>
                        </Typography>
                    </Alert>

                    <TextField
                        fullWidth
                        value={reason}
                        required
                        onChange={(e) => setReason(e.target.value)}
                        type={"text"}
                        multiline
                        rows={4}
                        inputProps={{ maxLength: 1000 }}
                        label={<Localized id="user-archiving-reason">_Powód archiwizacji</Localized>}
                    />

                    <TextField
                        sx={{ mt: 2 }}
                        fullWidth
                        value={password}
                        required
                        onChange={(e) => setPassword(e.target.value)}
                        type={"password"}
                        label={<Localized id="password">_Hasło</Localized>}
                        helperText={<Localized id="autorization-password-required"><span>Wymagana autoryzacja hasłem</span></Localized>}
                    />
                </DialogContentText>

                {serverError && (
                    <Alert sx={{ marginTop: 1 }} severity="error">
                        <Localized id={serverError}>
                            <span style={{ whiteSpace: 'pre-line' }}>{serverError}</span>
                        </Localized>
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <ArchiveButton
                    loading={loading}
                    onClick={handleSubmitClick}
                />
                <CancelButton
                    loading={loading}
                    onClick={onCancel}
                />
            </DialogActions>
        </>
    )
}